var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import MessageBox from "~/components/workspace/message/message-box.vue";
import MessageDetail from "~/components/workspace/message/message-detail.vue";
import { Dependencies } from "~/core/decorator";
import { ReminderMessageService } from "~/services/common-service/reminder-message.service";
import { ReminderService, ReminderMessageType } from "~/utils/reminder.service";
var workspaceModule = namespace("workspace");
var WorkMessageLegal = /** @class */ (function (_super) {
    __extends(WorkMessageLegal, _super);
    function WorkMessageLegal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // private unReadCount = 0;
        _this.msgDetail = {};
        _this.dialog = {
            messageBox: false,
            messageDetail: false
        };
        return _this;
    }
    Object.defineProperty(WorkMessageLegal.prototype, "messageLegalBoxVisible", {
        get: function () {
            return this.legalMessageBoxVisible;
        },
        set: function (value) {
            this.updateLegalMessageBoxVisible(value);
        },
        enumerable: false,
        configurable: true
    });
    WorkMessageLegal.prototype.mounted = function () {
        this.updateLegalUnReadCount();
        ReminderService.getInstance()
            .addListener(ReminderMessageType.LegalTaskMessage)
            .subscribe(this.updateLegalUnReadCount);
    };
    WorkMessageLegal.prototype.showNotify = function (data) {
        var _this = this;
        var option = {
            type: data.type,
            title: data.title,
            message: data.content,
            position: "bottom-right",
            iconClass: "el-icon-bell",
            customClass: "remind_notify",
            duration: data.duration || 6666
        };
        if (data.messageMode === "POPUP") {
            option.onClick = function () { return _this.onViewDetail(data); };
        }
        this.$notify(option);
    };
    WorkMessageLegal.prototype.onViewDetail = function (data) {
        this.msgDetail = data;
        this.dialog.messageDetail = true;
        // this.getUnReadCount()
    };
    __decorate([
        Dependencies(ReminderMessageService)
    ], WorkMessageLegal.prototype, "reminderMessageService", void 0);
    __decorate([
        workspaceModule.State
    ], WorkMessageLegal.prototype, "legalUnReadCount", void 0);
    __decorate([
        workspaceModule.State("messageLegalBoxVisible")
    ], WorkMessageLegal.prototype, "legalMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.Mutation
    ], WorkMessageLegal.prototype, "updateLegalMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.Action
    ], WorkMessageLegal.prototype, "updateLegalUnReadCount", void 0);
    __decorate([
        Prop()
    ], WorkMessageLegal.prototype, "isLegalMessage", void 0);
    WorkMessageLegal = __decorate([
        Component({
            components: {
                MessageBox: MessageBox,
                MessageDetail: MessageDetail
            }
        })
    ], WorkMessageLegal);
    return WorkMessageLegal;
}(Vue));
export default WorkMessageLegal;
